import { ComponentValuesType } from '../../../../lib/SkillComponents';
import CodeViewer from '../CodeViewer';
import ImageViewer from '../ImageViewer';
import RichTextViewer from '../RichTextViewer';
import SectionTitleViewer from '../SectionTitleViewer';
import UnsplashImageViewer from '../UnsplashImageViewer';
/** Does not contain PDF, Video,Labs or Question, must be handled separately */
const viewerFactory = {
    [ComponentValuesType.Image]: ImageViewer,
    [ComponentValuesType.RichText]: RichTextViewer,
    [ComponentValuesType.SectionTitle]: SectionTitleViewer,
    [ComponentValuesType.UnsplashImage]: UnsplashImageViewer,
    [ComponentValuesType.Code]: CodeViewer
};
export default viewerFactory;
//# sourceMappingURL=index.js.map